import React, { useState, ChangeEvent } from 'react';
import PillLabel from '../../../components/PillLabel';
import store from '../../../store';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../store';

import { RootState } from '../../../rootReducer';
import { setTableNumber } from '../../../features/cart/cart';
import Input from '../../components/Input';
import { WhyThisPopUp } from './WhyThisPopUp';
import { message } from 'antd';

type Props = {
  onSwitch: () => void;
};

const TableNumberField: React.FC<Props> = ({ onSwitch }) => {
  const [showWhyThis, setShowWhyThis] = useState(false);

  const [local, setLocal] = useState(
    store.getState().cart.order_create.table_number ?? '',
  );
  const order_type = useSelector<RootState, string>(
    state => state.cart.order_create.order_type,
  );
  const dispatch = useAppDispatch();

  return (
    <>
      <div className={'flex flex-col'}>
        <div className={'flex flex-row justify-between items-center '}>
          <div className="flex flex-row justify-left content-center items-center mb-2 mt-4">
            <label className="pl-4 block uppercase tracking-wide text-on-surface text-sm font-bold">
              Table Number
            </label>
            <div className="text-gray-900 items-center text-sm text-right -mt-1 ml-2">
              <PillLabel
                color="bg-error-container"
                label="Required"
                text_color="text-on-error-container"
              />
            </div>
          </div>
          <div className="text-gray-900 items-start text-sm text-right mx-4">
            <span
              onClick={() => setShowWhyThis(true)}
              className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-tertiary-container text-on-tertiary-container`}
            >
              Why do we ask this?
            </span>
          </div>
        </div>

        {/* {store.getState().restaurant.profile.is_pickup && (
          <div
            className="inline-flex space-x-2 truncate text-sm pl-4"
            onClick={onSwitch}
          >
            <span className="text-gray-500 truncate group-hover:text-gray-900">
              Switch to {order_type === 'dine_in' ? 'Pick Up' : 'Dine In'}
            </span>
          </div>
        )} */}
      </div>
      <div className="py-2 pr-4 pl-4  sm:h-1/5 max-h-1/5 sm:flex rounded bg-surface">
        <div className="p-4 flex felx-row w-full rounded-lg  justify-between bg-primary/10">
          <Input
            // @ts-ignore
            handleChange={e => {
              setLocal(e.target.value);
            }}
            handleBlur={e => {
              const re = /^[A-Za-z0-9.-]+$/;
              if (local === '' || re.test(local)) {
                dispatch(setTableNumber(local));
                if (
                  store
                    .getState()
                    .restaurant.profile.table_numbers.includes(local)
                ) {
                  message.success('Table number saved');
                }
              } else {
                setLocal('');
                dispatch(setTableNumber(''));
              }
            }}
            name="tableNumber"
            type="text"
            value={local}
            className={
              'appearance-none bg-surface-variant block w-full px-3 py-2 border border-outline-variant rounded-md placeholder-on-surface-variant/60 focus:ring-primary/70 focus:border-primary text-on-surface-variant transition duration-150 ease-in-out text-md sm:leading-5'
            }
            autoComplete="off"
            placeholder=""
          />
        </div>
      </div>
      {showWhyThis && (
        <WhyThisPopUp
          onCancel={() => {
            setShowWhyThis(false);
          }}
        />
      )}
    </>
  );
};

export default TableNumberField;
